import Vue from 'vue';
import Router from 'vue-router';
import store from './store/index';
import CertificatePage from './views/CertificatePage.vue';
import LoginPage from './views/LoginPage.vue';
import LandingPage from './views/LandingPage.vue';
import EventList from './views/EventList.vue';
import EventDetails from './views/EventDetails.vue';
import CodeApproved from './views/CodeApproved.vue';
import CodeFake from './views/CodeFake.vue';
import PageNotFound from './views/PageNotFound.vue';
import Report from './views/Report.vue';

Vue.use(Router);

function requireAuth(to: any, from: any, next: any) {
  // console.dir(to);
  if (store.getters.isLogin) {
    next();
  } else {
    store.commit('MUTATE_SHOW_NAVIGATION', false);
    next('/');
  }
}

function notRequireAuth(to: any, from: any, next: any) {
  if (store.getters.isLogin) {
    next('/event');
  } else {
    store.commit('MUTATE_SHOW_NAVIGATION', false);
    next();
  }
}

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: LoginPage,
      beforeEnter: notRequireAuth
    },
    {
      path: '/event',
      name: 'event',
      component: EventList,
      beforeEnter: requireAuth
    },
    {
      path: '/detail/:eventId',
      name: 'detail',
      component: EventDetails,
      beforeEnter: requireAuth
    },
    { path: '*', name: 'page-not-found', component: PageNotFound }
  ]
});

router.beforeEach((to: any, from: any, next: any) => {
  if (to.name === 'login') {
    store.commit('MUTATE_SHOW_NAVIGATION', false);
  } else {
    store.commit('MUTATE_SHOW_NAVIGATION', true);
  }
  next();
});

export default router;
